<template>
  <v-card color="#F5F5F5" class="back pa-4 mt-0 report-card">
    <v-card-title class="d-flex justify-space-between">
      <span>
        1.6 - {{ $t('Prevalência Solução Defeito') }}
        <v-tooltip color="white" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="black" dark v-bind="attrs" v-on="on">
              mdi-information-outline
            </v-icon>
          </template>
          <span class="black--text">{{
            $t(
              'Apresenta o número de ordens de serviço concluídas no período para cada tipo de solução defeito.'
            )
          }}</span>
        </v-tooltip></span
      >
      <v-btn
        @click="requestExcel"
        depressed
        small
        class="secondary-button mr-1"
      >
        <v-icon>mdi-microsoft-excel</v-icon>
      </v-btn></v-card-title
    >

    <v-divider></v-divider>
    <v-alert type="error" class="mt-3 pa-0" v-if="solutions.length == 0">
      {{ $t('Nenhuma registro encontrado') }}
    </v-alert>

    <v-card-text v-else>
      <v-simple-table class="main-table" dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th></th>
              <th class="text-left">
                <span class="ml-4"> {{ $t('Solução') }} </span>
              </th>
              <th class="text-center">{{ $t('Total de O.S.s') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in solutions" :key="item.id">
              <td></td>
              <td style="max-width: 60px">
                <span class="ml-2"> {{ item.solution }} </span>
              </td>
              <td style="max-width: 60px" class="text-center">
                {{ item.orders.length }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <div class="pagination">
        <div class="item-pagination block-two">
          <v-pagination
            class="pagination-item"
            v-model="page"
            :length="totalPages"
            :total-visible="3"
          ></v-pagination>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../services/ApiService'
export default {
  name: 'DefectSolutionPrevalence',

  props: {
    filterProp: Object,
  },

  created() {
    this.list()
  },

  data() {
    return {
      apiService: new ApiService(),
      solutions: [],
      totalPages: null,
      page: 1,
    }
  },
  watch: {
    page() {
      this.filterProp.page = this.page
      this.list()
    },
  },

  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `defect_Soluction_Prevalence_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/defectSoluctionPrevalence', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    async list() {
      await this.apiService
        .post('reports/defectSolutionPrevalence', this.filterProp)
        .then((response) => {
          this.solutions = response.content.objects
          this.totalPages = response.content.pager.totalPages
        })
        .catch((err) => {})
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/sass/variables.scss';
.mobile {
  display: none;
  @media (max-width: $tablet-1) {
    display: block;
  }
}
.desktop {
  @media (max-width: $tablet-1) {
    display: none;
  }
}
.gauge {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 600px) {
  .gauge {
    height: 50vh !important;
  }
}
</style>
